import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { RequestService } from 'src/app/core/request/request.service';

@Component({
  selector: 'dcc-new-request',
  templateUrl: './new-request.component.html',
  styleUrls: ['./new-request.component.scss'],
})
export class NewRequestComponent {
  name = '';
  description = '';
  serialNumbers = '';

  constructor(
    private toastr: ToastrService,
    private requestService: RequestService,
  ) {}

  async submitRequest() {
    if (!this.serialNumbers.length) {
      this.toastr.warning(`Serial numbers are required.`);
      return;
    }

    if (!this.name.length) {
      this.toastr.warning(`A name is required.`);
      return;
    }

    try {
      await this.requestService.submitNewRequest({
        serialNumbers: this.serialNumbers
          .split(',')
          .map((value) => value.trim().toUpperCase()),
        description: this.description,
        type: 'dcc',
        name: this.name,
      });
    } catch (e) {
      this.toastr.error(`Failed to submit the new request, please try again.`);
      return;
    }

    this.toastr.success(`Successfully submitted new request.`);
    this.name = this.description = this.serialNumbers = '';
  }
}
